<template>
  <div>
    <div
      v-if="numRoom > 0"
      :class="{'mt-6' : numRoom > 0 && isRakutenPLan}"
      class="room-number">
      {{ numRoom + 1 }}部屋目
    </div>

    <table class="table-common" >
      <tr class="label-inp">
        <td class="flex style-l" style="background-color: white">
          <div class="font-bold label-l">年齢区分</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data" style="margin-left: 20px">人数（会員）</span>
              </div>
              <div class="elm gap-2" style="margin-left: 30px">
                <span class="content-data">人数（ビジター）</span>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l mr-2">大人（男性）</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select class="select-items" v-model="dataBinding.member.man"  
                    :disabled="disableDropdownAdult(dataBinding.member.man)">
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in memberManOptions"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    class="select-items"
                    v-model="dataBinding.visitors.man"
                    :disabled="disableVisitor || disableDropdownAdult(dataBinding.visitors.man)"
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in visitorManOptions"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2 hidden">
                <span class="content-data">子ども</span>
                <div class="flex">
                  <a-popover
                    v-model="showPopoverMember"
                    trigger="click"
                    class="children-attach"
                    style="max-width: 500px"
                  >
                    <div class="flex">
                      <a-input
                        class="input-value-children"
                        size="large"
                        v-model="countMemberChildren"
                        @keypress="
                          ($event) => {
                            $event.preventDefault()
                            return false
                          }
                        "
                        disabled
                      />
                      <span class="self-center ml-2">名</span>
                    </div>
                    <div slot="content" class="children-attach-content">
                      <div class="popover-block-first">
                        <div class="block-first-title">小学生</div>
                        <div class="block-first-content">
                          <div class="set-value-group">
                            <div class="set-value-name">高学年</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.memberChildren.childrenType10"
                                class="select-items"
                                :disabled="
                                  memberChildren10Options.length === 1 ||
                                  !chldDivEnabled.memberType10
                                "
                              >
                                <a-select-option
                                  :value="el.value"
                                  v-for="(el, index) in memberChildren10Options"
                                  :key="`room-${index}`"
                                >
                                  {{ el.label }}
                                </a-select-option>
                              </a-select>
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                          <div class="set-value-group">
                            <div class="set-value-name">低学年</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.memberChildren.childrenType15"
                                class="select-items"
                                :disabled="
                                  memberChildren15Options.length === 1 ||
                                  !chldDivEnabled.memberType15
                                "
                              >
                                <a-select-option
                                  :value="el.value"
                                  v-for="(el, index) in memberChildren15Options"
                                  :key="`room-${index}`"
                                >
                                  {{ el.label }}
                                </a-select-option>
                              </a-select>
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="popover-block-second">
                        <div class="block-second-title">幼児</div>
                        <div class="block-second-content">
                          <div class="set-value-group">
                            <div class="set-value-name">食事・布団付</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.memberChildren.childrenType20"
                                class="select-items"
                                :disabled="
                                  memberChildren20Options.length === 1 ||
                                  !chldDivEnabled.memberType20
                                "
                              >
                                <a-select-option
                                  :value="el.value"
                                  v-for="(el, index) in memberChildren20Options"
                                  :key="`room-${index}`"
                                >
                                  {{ el.label }}
                                </a-select-option>
                              </a-select>
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                          <div class="set-value-group">
                            <div class="set-value-name">食事のみ</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.memberChildren.childrenType30"
                                class="select-items"
                                :disabled="
                                  memberChildren30Options.length === 1 ||
                                  !chldDivEnabled.memberType30
                                "
                              >
                                <a-select-option
                                  :value="el.value"
                                  v-for="(el, index) in memberChildren30Options"
                                  :key="`room-${index}`"
                                >
                                  {{ el.label }}
                                </a-select-option>
                              </a-select>
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="popover-block-three">
                        <div class="block-three-content">
                          <div class="set-value-group">
                            <div class="set-value-name">布団のみ</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.memberChildren.childrenType40"
                                class="select-items"
                                :disabled="
                                  memberChildren40Options.length === 1 ||
                                  !chldDivEnabled.memberType40
                                "
                              >
                                <a-select-option
                                  :value="el.value"
                                  v-for="(el, index) in memberChildren40Options"
                                  :key="`room-${index}`"
                                >
                                  {{ el.label }}
                                </a-select-option>
                              </a-select>
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                          <div class="set-value-group">
                            <div class="set-value-name">食事・布団不要</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.memberChildren.childrenType50"
                                :options="memberChildren50Options"
                                class="select-items"
                                :disabled="
                                  memberChildren50Options.length === 1 ||
                                  !chldDivEnabled.memberType50
                                "
                              />
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a-popover>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">大人（女性）</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select class="select-items" v-model="dataBinding.member.woman"
                   :disabled="disableDropdownAdult(dataBinding.member.woman)">
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in memberWomanOptions"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    class="select-items"
                    v-model="dataBinding.visitors.woman"
                    :disabled="disableVisitor || disableDropdownAdult(dataBinding.visitors.woman)"
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in visitorWomanOptions"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2 hidden">
                <span class="content-data">子ども</span>
                <div class="flex">
                  <a-popover
                    v-model="showPopoverVisitor"
                    trigger="click"
                    class="children-attach"
                    style="max-width: 500px"
                  >
                    <div class="flex">
                      <a-input
                        class="input-value-children"
                        size="large"
                        v-model="countVisitorChildren"
                        @keypress="
                          ($event) => {
                            $event.preventDefault()
                            return false
                          }
                        "
                        disabled
                      />
                      <span class="self-center ml-2">名</span>
                    </div>
                    <div slot="content" class="children-attach-content">
                      <div class="popover-block-first">
                        <div class="block-first-title">小学生</div>
                        <div class="block-first-content">
                          <div class="set-value-group">
                            <div class="set-value-name">高学年</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.visitorChildren.childrenType10"
                                :options="visitorChildren10Options"
                                class="select-items"
                                :disabled="
                                  visitorChildren10Options.length === 1 ||
                                  !chldDivEnabled.visitorType10
                                "
                              />
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                          <div class="set-value-group">
                            <div class="set-value-name">低学年</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.visitorChildren.childrenType15"
                                :options="visitorChildren15Options"
                                class="select-items"
                                :disabled="
                                  visitorChildren15Options.length === 1 ||
                                  !chldDivEnabled.visitorType15
                                "
                              />
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="popover-block-second">
                        <div class="block-second-title">幼児</div>
                        <div class="block-second-content">
                          <div class="set-value-group">
                            <div class="set-value-name">食事・布団付</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.visitorChildren.childrenType20"
                                :options="visitorChildren20Options"
                                class="select-items"
                                :disabled="
                                  visitorChildren20Options.length === 1 ||
                                  !chldDivEnabled.visitorType20
                                "
                              />
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                          <div class="set-value-group">
                            <div class="set-value-name">食事のみ</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.visitorChildren.childrenType30"
                                :options="visitorChildren30Options"
                                class="select-items"
                                :disabled="
                                  visitorChildren30Options.length === 1 ||
                                  !chldDivEnabled.visitorType30
                                "
                              />
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="popover-block-three">
                        <div class="block-three-content">
                          <div class="set-value-group">
                            <div class="set-value-name">布団のみ</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.visitorChildren.childrenType40"
                                :options="visitorChildren40Options"
                                class="select-items"
                                :disabled="
                                  visitorChildren40Options.length === 1 ||
                                  !chldDivEnabled.visitorType40
                                "
                              />
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                          <div class="set-value-group">
                            <div class="set-value-name">食事・布団不要</div>
                            <div class="items">
                              <a-select
                                v-model="dataBinding.visitorChildren.childrenType50"
                                :options="visitorChildren50Options"
                                class="select-items"
                                :disabled="
                                  visitorChildren50Options.length === 1 ||
                                  !chldDivEnabled.visitorType50
                                "
                              />
                              <span class="ml-2">人</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a-popover>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">小学生高学年</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.memberChildren.childrenType10"
                    class="select-items"
                    :disabled="
                      memberChildren10Options.length === 1 || !chldDivEnabled.memberType10
                    "
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in memberChildren10Options"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.visitorChildren.childrenType10"
                    :options="visitorChildren10Options"
                    class="select-items"
                    :disabled="
                      visitorChildren10Options.length === 1 ||
                      !chldDivEnabled.visitorType10 ||
                      disableVisitor
                    "
                  />
                  <span class="content-data">名</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">小学生低学年</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.memberChildren.childrenType15"
                    class="select-items"
                    :disabled="
                      memberChildren15Options.length === 1 || !chldDivEnabled.memberType15
                    "
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in memberChildren15Options"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.visitorChildren.childrenType15"
                    :options="visitorChildren15Options"
                    class="select-items"
                    :disabled="
                      visitorChildren15Options.length === 1 ||
                      !chldDivEnabled.visitorType15 ||
                      disableVisitor
                    "
                  />
                  <span class="content-data">名</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">幼児食事・布団付</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.memberChildren.childrenType20"
                    class="select-items"
                    :disabled="
                      memberChildren20Options.length === 1 || !chldDivEnabled.memberType20
                    "
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in memberChildren20Options"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.visitorChildren.childrenType20"
                    :options="visitorChildren20Options"
                    class="select-items"
                    :disabled="
                      visitorChildren20Options.length === 1 ||
                      !chldDivEnabled.visitorType20 ||
                      disableVisitor
                    "
                  />
                  <span class="content-data">名</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">幼児食事のみ</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.memberChildren.childrenType30"
                    class="select-items"
                    :disabled="
                      memberChildren30Options.length === 1 || !chldDivEnabled.memberType30
                    "
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in memberChildren30Options"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.visitorChildren.childrenType30"
                    :options="visitorChildren30Options"
                    class="select-items"
                    :disabled="
                      visitorChildren30Options.length === 1 ||
                      !chldDivEnabled.visitorType30 ||
                      disableVisitor
                    "
                  />
                  <span class="content-data">名</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">幼児布団のみ</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.memberChildren.childrenType40"
                    class="select-items"
                    :disabled="
                      memberChildren40Options.length === 1 || !chldDivEnabled.memberType40
                    "
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in memberChildren40Options"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.visitorChildren.childrenType40"
                    :options="visitorChildren40Options"
                    class="select-items"
                    :disabled="
                      visitorChildren40Options.length === 1 ||
                      !chldDivEnabled.visitorType40 ||
                      disableVisitor
                    "
                  />
                  <span class="content-data">名</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr class="label-inp">
        <td class="flex style-l">
          <div class="font-bold label-l">幼児食事・布団不要</div>
        </td>
        <td class="data">
          <div class="items-data">
            <div class="label-data menber">
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.memberChildren.childrenType50"
                    class="select-items"
                    :disabled="
                      memberChildren50Options.length === 1 || !chldDivEnabled.memberType50
                    "
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in memberChildren50Options"
                      :key="`room-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                  <span class="content-data">名</span>
                </div>
              </div>
              <div class="elm gap-2">
                <span class="content-data"></span>
                <div class="flex">
                  <a-select
                    v-model="dataBinding.visitorChildren.childrenType50"
                    :options="visitorChildren50Options"
                    class="select-items"
                    :disabled="
                      visitorChildren50Options.length === 1 ||
                      !chldDivEnabled.visitorType50 ||
                      disableVisitor
                    "
                  />
                  <span class="content-data">名</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>

      <tr class="label-inp"></tr>
      <div class="text-right">
        <p
          class="ml-4 font-bold text-primary"
          v-for="(errorMsg, idx) in roomErrors"
          :key="`room-${idx}`"
        >
          {{ errorMsg }}
      </p>
      </div>
      <div class="text-right mt-1">{{ countPeopleInRoom }}人</div>
    </table>
    <div class="total-value hidden">
      合計
      <span v-if="dataBinding && dataBinding.roomAmount !== null">{{
        dataBinding.roomAmount | formatCurrency
      }}</span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'
import { PLAN_BASE_ON_PRICE } from '@/constants/plan'

export default {
  mixins: [func_utils, plan_utils],
  props: ['value', 'numRoom', 'vacancyCalendar', 'roomErrors', 'deputation'],
  data() {
    return {
      TEST: true,
      warningMessage: {
        firstName: '名（ローマ字）を入力してください。',
        familyName: '姓（ローマ字）を入力してください。',
        gender: '性別を入力してください',
        age: '年齢を入力してください'
      },
      childTypeLabel: {
        childrenType10: '小学生高学年',
        childrenType15: '小学生低学年',
        childrenType20: '幼児食事・布団付',
        childrenType30: '幼児食事のみ',
        childrenType40: '幼児布団のみ',
        childrenType50: '幼児食事・布団不要'
      },
      representative: {
        familyNameKana: '',
        familyName: '',
        firstNameKana: '',
        firstName: ''
      },
      adultTypeData: [],
      childTypeData: {
        childrenType10: [],
        childrenType15: [],
        childrenType20: [],
        childrenType30: [],
        childrenType40: [],
        childrenType50: []
      },
      dateFormat: 'YYYY/MM/DD',
      showPopoverMember: false,
      showPopoverVisitor: false,
      stayDayDetails: [],
      dataBinding: {
        roomPrice: null,
        stayDay: null,
        adultPrice: 0,
        member: {
          man: 0,
          woman: 0
        },
        visitors: {
          man: 0,
          woman: 0
        },
        chldaManHeadCnt: 0,
        chldaWomanHeadCnt: 0,
        memberChildren: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        },
        visitorChildren: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        },
        totalAmount: 0,
        roomAmount: 0,
        memberCount: 0,
        visitorCount: 0,
        childrenCount: 0
      },
      stayDay: null,
      stayNights: 0, // number of days
      price: {},
      maxStayCapacity: null,
      minRoomStock: null,
      roomCapacity: 0,
      limitRooms: 0,
      stateChildInfos: [],
      stateVacancyCalendars: [],
    }
  },
  mounted() {
    if (this.value) {
      this.dataBinding = JSON.parse(JSON.stringify(this.value))
    }
    if (this.customerPlanState) {
      this.stayDay = this.customerPlanState.stayDay
      this.stayNights = this.customerPlanState.stayNights
      this.stayDayDetails = Array.isArray(this.customerPlanState.detailDays)
        ? this.customerPlanState.detailDays
        : []
      this.maxStayCapacity = this.customerPlanState.maxStayCapacity
    }
    this.minRoomStock = this.getMinRoomStock(this.stayDayDetails)
    if (this.isRakutenPLan) {
      this.setupAdultInfo()
      this.setupChildInfo()
      this.triggerChange()
    }
  },
  computed: {
    adultAgeRange() {
      return _.range(20, 100, 1)
    },
    childAgeRange() {
      return _.range(1, 20, 1)
    },
    isRakutenPLan() {
      return _.get(this.getPlanInfo, 'menuInformation.extSystemCd') === 'RakutenT'
    },
    disableVisitor() {
      return this.getPlanInfo.planUsage?.usageDetailStay?.visitorAvailDiv === '0'
    },
    countAudultInRoom(){
       return (
        this.dataBinding.member.man +
        this.dataBinding.member.woman +
        this.dataBinding.visitors.man +
        this.dataBinding.visitors.woman 
      )
    },
    countPeopleInRoom() {
      return (
        this.dataBinding.member.man +
        this.dataBinding.member.woman +
        this.dataBinding.visitors.man +
        this.dataBinding.visitors.woman +
        this.countMemberChildren +
        this.countVisitorChildren
      )
    },
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.customerPlan', null))
    },
    selectedDayCalendar() {
      const vacancyCalendars = this.vacancyCalendar[this.numRoom]?.vacancyCalendars || []
      const stayDays = []
      for (let i = 0; i < this.stayNights; i++) {
        stayDays.push(moment(this.stayDay).add(i, 'days').format(this.dateFormat))
      }
      let result = vacancyCalendars.filter((v) =>
        stayDays.includes(moment(v.stayDay).format(this.dateFormat))
      )
      if(result.length===0) result = this.getOriginCalendar?.filter((x) => 
        stayDays.includes(moment(x.stayDay).format(this.dateFormat))
      )
      return result;
    },
    countMemberChildren() {
      const memberChildren =
        this.dataBinding && this.dataBinding.memberChildren
          ? this.dataBinding.memberChildren
          : null
      return Object.keys(memberChildren)
        .map((key) => memberChildren[key])
        .reduce((a, b) => a + b, 0)
    },
    countVisitorChildren() {
      const visitorChildren =
        this.dataBinding && this.dataBinding.visitorChildren
          ? this.dataBinding.visitorChildren
          : null
      return Object.keys(visitorChildren)
        .map((key) => visitorChildren[key])
        .reduce((a, b) => a + b, 0)
    },
    adultCount(){
        const member =
        this.dataBinding && this.dataBinding.member ? this.dataBinding.member : null
      const visitor =
        this.dataBinding && this.dataBinding.visitors ? this.dataBinding.visitors : null

      return member.man + member.woman + visitor.man + visitor.woman
    },
    roomAmount() {
      if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
        const amount = this.stayDayDetails
          .map((e) => e.roomPrice)
          .reduce((pre, cur) => pre + cur, 0)
        return amount
      }
      const member =
        this.dataBinding && this.dataBinding.member ? this.dataBinding.member : null
      const visitor =
        this.dataBinding && this.dataBinding.visitors ? this.dataBinding.visitors : null
      const memberChildren =
        this.dataBinding && this.dataBinding.memberChildren
          ? this.dataBinding.memberChildren
          : null
      const visitorChildren =
        this.dataBinding && this.dataBinding.visitorChildren
          ? this.dataBinding.visitorChildren
          : null
      let amount = 0
      this.selectedDayCalendar.forEach((vacancy) => {
        // member adults
        amount += (member.man + member.woman) * vacancy.price
        // visitor adults
        amount += (visitor.man + visitor.woman) * vacancy.adultPrice
        // member childrens
        amount +=
          memberChildren.childrenType10 *
          this.getMemberChildPrice('childrenType10', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType15 *
          this.getMemberChildPrice('childrenType15', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType20 *
          this.getMemberChildPrice('childrenType20', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType30 *
          this.getMemberChildPrice('childrenType30', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType40 *
          this.getMemberChildPrice('childrenType40', vacancy.childrenPriceTable)
        amount +=
          memberChildren.childrenType50 *
          this.getMemberChildPrice('childrenType50', vacancy.childrenPriceTable)
        // visitor childrens
        amount +=
          visitorChildren.childrenType10 *
          this.getVisitorChildPrice('childrenType10', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType15 *
          this.getVisitorChildPrice('childrenType15', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType20 *
          this.getVisitorChildPrice('childrenType20', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType30 *
          this.getVisitorChildPrice('childrenType30', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType40 *
          this.getVisitorChildPrice('childrenType40', vacancy.childrenPriceTable)
        amount +=
          visitorChildren.childrenType50 *
          this.getVisitorChildPrice('childrenType50', vacancy.childrenPriceTable)
      })
      return amount
    },
    totalChild() {
      return this.countMemberChildren + this.countVisitorChildren
    },
    totalPeopleCnt() {
      const adultMemberSlot = this.dataBinding.member.man + this.dataBinding.member.woman
      const adultVisitorSlot =
        this.dataBinding.visitors.man + this.dataBinding.visitors.woman
      return adultMemberSlot + adultVisitorSlot + this.totalChild
    },
    countRoomPeopleSlot() {
      let maxSlot =
        this.dataBinding.member.man +
        this.dataBinding.member.woman +
        this.dataBinding.visitors.man +
        this.dataBinding.visitors.woman
      const memberChildren =
        this.dataBinding && this.dataBinding.memberChildren
          ? this.dataBinding.memberChildren
          : null
      const memberChldSlotCnt = Object.keys(memberChildren)
        .filter((key) => !['childrenType30', 'childrenType50'].includes(key))
        .map((key) => memberChildren[key])
        .reduce((a, b) => a + b, 0)

      const visitorChildren =
        this.dataBinding && this.dataBinding.visitorChildren
          ? this.dataBinding.visitorChildren
          : null
      const visitorChldSlotCnt = Object.keys(visitorChildren)
        .filter((key) => !['childrenType30', 'childrenType50'].includes(key))
        .map((key) => visitorChildren[key])
        .reduce((a, b) => a + b, 0)
      maxSlot += memberChldSlotCnt + visitorChldSlotCnt

      return maxSlot
    },
    memberManOptions() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const num =
        maxAdultPeople - (this.countRoomPeopleSlot - this.dataBinding.member.man)
      return this.getNumberOptions(num)
    },
    memberWomanOptions() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const num =
        maxAdultPeople - (this.countRoomPeopleSlot - this.dataBinding.member.woman)
      return this.getNumberOptions(num)
    },
    visitorManOptions() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const num =
        maxAdultPeople - (this.countRoomPeopleSlot - this.dataBinding.visitors.man)
      return this.getNumberOptions(num)
    },
    visitorWomanOptions() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const num =
        maxAdultPeople - (this.countRoomPeopleSlot - this.dataBinding.visitors.woman)
      return this.getNumberOptions(num)
    },
    memberChildren10Options() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const current = _.get(this.dataBinding, 'memberChildren.childrenType10', 0)
      const num = maxAdultPeople - (this.countRoomPeopleSlot - current)
      return this.getNumberOptions(num)
    },
    memberChildren15Options() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const current = _.get(this.dataBinding, 'memberChildren.childrenType15', 0)
      const num = maxAdultPeople - (this.countRoomPeopleSlot - current)
      return this.getNumberOptions(num)
    },
    memberChildren20Options() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const current = _.get(this.dataBinding, 'memberChildren.childrenType20', 0)
      const num = maxAdultPeople - (this.countRoomPeopleSlot - current)
      return this.getNumberOptions(num)
    },
    memberChildren30Options() {
      return this.getNumberOptions(19)
    },
    memberChildren40Options() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const current = _.get(this.dataBinding, 'memberChildren.childrenType40', 0)
      const num = maxAdultPeople - (this.countRoomPeopleSlot - current)
      return this.getNumberOptions(num)
    },
    memberChildren50Options() {
      return this.getNumberOptions(19)
    },
    visitorChildren10Options() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const current = _.get(this.dataBinding, 'visitorChildren.childrenType10', 0)
      const num = maxAdultPeople - (this.countRoomPeopleSlot - current)
      return this.getNumberOptions(num)
    },
    visitorChildren15Options() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const current = _.get(this.dataBinding, 'visitorChildren.childrenType15', 0)
      const num = maxAdultPeople - (this.countRoomPeopleSlot - current)
      return this.getNumberOptions(num)
    },
    visitorChildren20Options() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const current = _.get(this.dataBinding, 'visitorChildren.childrenType20', 0)
      const num = maxAdultPeople - (this.countRoomPeopleSlot - current)
      return this.getNumberOptions(num)
    },
    visitorChildren30Options() {
      return this.getNumberOptions(19)
    },
    visitorChildren40Options() {
      const maxAdultPeople = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      const current = _.get(this.dataBinding, 'visitorChildren.childrenType40', 0)
      const num = maxAdultPeople - (this.countRoomPeopleSlot - current)
      return this.getNumberOptions(num)
    },
    visitorChildren50Options() {
      return this.getNumberOptions(19)
    },
    getOriginCalendar() {
      return _.cloneDeep(_.get(this.$store.state.order, 'originCalendar', null))
    },
    chldDivEnabled() {
      const childDiv = {
        memberType10: 0,
        memberType15: 0,
        memberType20: 0,
        memberType30: 0,
        memberType40: 0,
        memberType50: 0,
        visitorType10: 0,
        visitorType15: 0,
        visitorType20: 0,
        visitorType30: 0,
        visitorType40: 0,
        visitorType50: 0
      }
      if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
          this.stateChildInfos.forEach((info) => {
          if (info.childDiv === this.CONST_DATA.CHILD_DIV.UPPER_ELEMENTARY_SCHOOL) {
            childDiv.memberType10 += 1
            childDiv.visitorType10 += 1
          } else if (info.childDiv === this.CONST_DATA.CHILD_DIV.LOWER_ELEMENTARY_SCHOOL) {
            childDiv.memberType15 += 1
            childDiv.visitorType15 += 1
          } else if (info.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_BEDDING_MEAL) {
            childDiv.memberType20 += 1
            childDiv.visitorType20 += 1
          } else if (info.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_MEAL) {
            childDiv.memberType30 += 1
            childDiv.visitorType30 += 1
          } else if (info.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_BEDDING) {
            childDiv.memberType40 += 1
            childDiv.visitorType40 += 1
          } else if (info.childDiv === this.CONST_DATA.CHILD_DIV.INFANT) {
            childDiv.memberType50 += 1
            childDiv.visitorType50 += 1
          }
        })

        Object.keys(childDiv).forEach((key) => {
          if (childDiv[key] !== 0) {
            childDiv[key] = true
          } else {
            childDiv[key] = false
          }
        })
        return childDiv
      } else {
        for (let i = 0; i < this.stayNights; i++) {
          const checkDay = moment(this.stayDay).add(i, 'days')
          if (this.stateVacancyCalendars) {
            const checkVacancy = _.get(
              this.stateVacancyCalendars.filter((v) =>
                moment(v.stayDay).isSame(checkDay, 'day')
              ),
              '[0]',
              null
            ) || _.get( this.getOriginCalendar.filter((x) => moment(x.stayDay).isSame(checkDay, 'day')),'[0]',null);
            if (checkVacancy) {
              const childrenPriceTable = checkVacancy.childrenPriceTable || []
              childrenPriceTable.forEach((chldTable) => {
                if (
                  chldTable.childDiv ===
                    this.CONST_DATA.CHILD_DIV.UPPER_ELEMENTARY_SCHOOL &&
                  chldTable.price !== null
                ) {
                  childDiv.memberType10 += 1
                } else if (
                  chldTable.childDiv ===
                    this.CONST_DATA.CHILD_DIV.LOWER_ELEMENTARY_SCHOOL &&
                  chldTable.price !== null
                ) {
                  childDiv.memberType15 += 1
                } else if (
                  chldTable.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_BEDDING_MEAL &&
                  chldTable.price !== null
                ) {
                  childDiv.memberType20 += 1
                } else if (
                  chldTable.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_MEAL &&
                  chldTable.price !== null
                ) {
                  childDiv.memberType30 += 1
                } else if (
                  chldTable.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_BEDDING &&
                  chldTable.price !== null
                ) {
                  childDiv.memberType40 += 1
                } else if (
                  chldTable.childDiv === this.CONST_DATA.CHILD_DIV.INFANT &&
                  chldTable.price !== null
                ) {
                  childDiv.memberType50 += 1
                }

                if (
                  chldTable.childDiv ===
                    this.CONST_DATA.CHILD_DIV.UPPER_ELEMENTARY_SCHOOL &&
                  chldTable.childPrice !== null
                ) {
                  childDiv.visitorType10 += 1
                } else if (
                  chldTable.childDiv ===
                    this.CONST_DATA.CHILD_DIV.LOWER_ELEMENTARY_SCHOOL &&
                  chldTable.childPrice !== null
                ) {
                  childDiv.visitorType15 += 1
                } else if (
                  chldTable.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_BEDDING_MEAL &&
                  chldTable.childPrice !== null
                ) {
                  childDiv.visitorType20 += 1
                } else if (
                  chldTable.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_MEAL &&
                  chldTable.childPrice !== null
                ) {
                  childDiv.visitorType30 += 1
                } else if (
                  chldTable.childDiv === this.CONST_DATA.CHILD_DIV.INFANT_BEDDING &&
                  chldTable.childPrice !== null
                ) {
                  childDiv.visitorType40 += 1
                } else if (
                  chldTable.childDiv === this.CONST_DATA.CHILD_DIV.INFANT &&
                  chldTable.childPrice !== null
                ) {
                  childDiv.visitorType50 += 1
                }
              })
            }
          }
        }
      }
      Object.keys(childDiv).forEach((key) => {
        if (childDiv[key] === +this.stayNights) {
          childDiv[key] = true
        } else {
          childDiv[key] = false
        }
      })
      return childDiv
    },
  },
  watch: {
    totalPeopleCnt() {
      this.dataBinding.childrenCount = this.totalChild
      this.$emit('input', this.dataBinding)
      const adultMemberSlot = this.dataBinding.member.man + this.dataBinding.member.woman
      const adultVisitorSlot =
      this.dataBinding.visitors.man + this.dataBinding.visitors.woman
      this.$emit('changePeopleCnt', adultMemberSlot + adultVisitorSlot + this.totalChild)
      this.triggerChange()
    },
    roomAmount() {
      this.dataBinding.roomAmount = this.roomAmount
      this.dataBinding.adultCount = this.adultCount
      this.dataBinding.childrenCount = this.totalChild
      this.$emit('input', this.dataBinding)
      this.triggerChange()
    },
    deputation(people) {
      if (!_.isEmpty(people) && people.numRoom !== this.numRoom) {
        this.removeDeputation()
      }
    },
    vacancyCalendar() {
      if(this.vacancyCalendar[this.numRoom]?.vacancyCalendars || this.vacancyCalendar[this.numRoom]?.childPriceInfo){
        // 60269の後続対応として修正予定
        this.stateVacancyCalendars = this.vacancyCalendar.vacancyCalendars || [];
        this.stateChildInfos = this.vacancyCalendar[this.numRoom].childPriceInfo?.childInfos || [];
      }
    },
  },
  methods: {
    disableDropdownAdult(value){
      const maxPeopleInRoom = this.maxStayCapacity ? this.maxStayCapacity : this.limitRooms
      // 布団あり子ども区分の合計
      const childrenWithBeddingCount = 
        this.dataBinding.memberChildren.childrenType10 +
        this.dataBinding.memberChildren.childrenType15 +
        this.dataBinding.memberChildren.childrenType20 +
        this.dataBinding.memberChildren.childrenType40 +
        this.dataBinding.visitorChildren.childrenType10 +
        this.dataBinding.visitorChildren.childrenType15 +
        this.dataBinding.visitorChildren.childrenType20 +
        this.dataBinding.visitorChildren.childrenType40;
      
      return this.countAudultInRoom >= maxPeopleInRoom - childrenWithBeddingCount && value == 0 && value != maxPeopleInRoom
    },
    setupAdultInfo() {
      this.$nextTick(() => {
        if (this.value.adultCount) {
          for (let i = 1; i <= this.value.adultCount; i++) {
            this.adultTypeData.push({
              index: i,
              type: 'member',
              gender: 'male',
              age: null,
              isDeputation: false,
              warningType: [],
              numRoom: this.numRoom
            })
          }
          this.$emit('changeAdultTypeData', this.adultTypeData, this.numRoom)
        }
      })
    },
    setupChildInfo() {

      this.$nextTick(() => {
        if (this.dataBinding.childrenCount || true) {
          Object.keys(this.dataBinding.memberChildren).forEach((child) => {
            const count = this.dataBinding.memberChildren[child]
            if (count) {
              let i = 0;
              for (i = 1; i <= count; i++) {
                this.childTypeData[child].push({
                  index: i,
                  type: 'member',
                  familyName: null,
                  firstName: null,
                  gender: 'male',
                  age: null,
                  warningType: [],
                  childType: child
                })
              }
              this.dataBinding.chldaManHeadCnt += (i - 1);
              this.$emit('changeChildTypeData', this.childTypeData, this.numRoom)
            }
          })
        }
      })
    },
    removeDeputation() {
      this.adultTypeData.forEach((people) => {
        people.isDeputation = false
      })
    },
    changeDeputation(index) {
      this.adultTypeData.forEach((people) => {
        if (people.index == index) {
          people.isDeputation = true
          this.$emit('changeDeputation', people, this.numRoom)
        } else {
          people.isDeputation = false
        }
      })
      this.$emit('changeAdultTypeData', this.adultTypeData, this.numRoom)
    },
    changeRepresentative() {
      this.$emit('changeRepresentative', this.representative, this.numRoom)
    },
    countNewAdultMember() {
      let memberMan = 0
      let memberWoman = 0
      let visistorMan = 0
      let visistorWoman = 0
      this.adultTypeData.forEach((people) => {
        switch (people.type) {
          case 'member':
            if (people.gender === 'male') memberMan++
            else if (people.gender === 'female') memberWoman++
            break
          case 'visistor':
            if (people.gender === 'male') visistorMan++
            else if (people.gender === 'female') visistorWoman++
            break

          default:
            break
        }
      })
      this.dataBinding.member.man = memberMan
      this.dataBinding.member.woman = memberWoman
      this.dataBinding.visitors.man = visistorMan
      this.dataBinding.visitors.woman = visistorWoman
    },
    countNewChildMember() {
      let member = {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      }
      let visistor = {
        childrenType10: 0,
        childrenType15: 0,
        childrenType20: 0,
        childrenType30: 0,
        childrenType40: 0,
        childrenType50: 0
      }
      let childMan = 0
      let childWoman = 0
      Object.keys(this.dataBinding.memberChildren).forEach((childType) => {
        this.childTypeData[childType].forEach((people) => {
          if (people.gender) {
            switch (people.type) {
              case 'member':
                member[childType]++
                break
              case 'visistor':
                visistor[childType]++
                break
              default:
                break
            }
            if (people.gender === 'male') {
              childMan++
            } else if (people.gender === 'female'){
              childWoman++
            }
          }
        })
      })
      this.dataBinding.memberChildren = member
      this.dataBinding.visitorChildren = visistor
      this.dataBinding.chldaManHeadCnt = childMan
      this.dataBinding.chldaWomanHeadCnt = childWoman
    },
    triggerChange() {
      this.$emit('change', this.dataBinding)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.ant-radio-group {
  display: flex;
}
</style>
